module.exports = __webpack_public_path__ + "static/media/phonepay.745407fc.png";